import { HeaderActionBack, Header } from "@/components/Header"
import { Layout } from "@/components/Layout"
import { SpinLoading } from "antd-mobile";
import { DynamicForm } from "@/pages/trade/components/DynamicForm"
import { formItems } from "./data"
import { useLogic } from "./useLogic";
import styles from './index.module.scss';

export const PageUserBillDetail = () => {
  const logic = useLogic();
  return <Layout
    scrollable
    backgroundImage={false}
    header={
      <Header
        title={"账变详情"}
        leftActions={<HeaderActionBack />}
      />
    }
  >
    <div className={styles.main}>
      {
        logic.loading ? 
        <div className={styles.loading_box}><SpinLoading style={{ '--size': '22px' }} className={styles.loading_icon} /></div>  : null
      }
      <div className={styles.form} key={1}>
        <DynamicForm
          disabled={true}
          items={formItems}
          onRef={logic.onFormRef}
        />
      </div>
    </div>

  </Layout>
}